let fireriskUrl = ''
let firesightUrl = ''
let planningUrl = ''
let OpsUrl = ''
// Matches resource-dispatcher's terraform/auth0/ SPA client callback URLs
// (local dev port 6785, deployed subdomain "web-dispatcher-<env>").
let webDispatcherUrl = ''
// K8s-only: weather is deployed as weather-<env>.<cluster>.<group>.<domain>, with no legacy
// 3-part (my.technosylva.com / my-dev.technosylva.ca) deployment, so it stays '' there.
let weatherUrl = ''
if (window.location.hostname === 'localhost') {
  fireriskUrl = 'http://localhost:3077'
  OpsUrl = 'http://localhost:3077'
  firesightUrl = 'http://localhost:3078'
  planningUrl = 'http://localhost:3079'
  webDispatcherUrl = 'http://localhost:6785'
  weatherUrl = 'http://localhost:5173'
} else {
  const parts = window.location.hostname.split('.')
  if (parts.length === 5) {
    // K8s Url format: appName-env.cluster.group.domain
    // example  ops-stg.us01.live.technosylva.com
    const env = parts[0].split('-')[1] // undefined for pro. e.g.: dev/stg
    const cluster = parts[1] // e.g.: us01
    const group = parts[2] // e.g.: live/sandbox
    const domain = parts[3] + '.' + parts[4] // e.g.: technosylva.com

    // K8s apps live at appName-env.cluster.group.domain — all links must keep the cluster.group segment.
    OpsUrl = `https://firerisk${env ? '-' + env : ''}.${cluster}.${group}.${domain}`
    fireriskUrl = `https://firerisk${env ? '-' + env : ''}.${cluster}.${group}.${domain}`
    firesightUrl = `https://firesight${env ? '-' + env : ''}.${cluster}.${group}.${domain}`
    planningUrl = `https://planning${env ? '-' + env : ''}.${cluster}.${group}.${domain}`
    webDispatcherUrl = `https://web-dispatcher${env ? '-' + env : ''}.${cluster}.${group}.${domain}`
    weatherUrl = `https://weather${env ? '-' + env : ''}.${cluster}.${group}.${domain}`
  } else if (parts.length === 3) {
    // domain format appName-env.domain
    const env = parts[0].split('-')[1] // undefined for pro. e.g.: dev/stg
    const domain = parts[1] + '.' + parts[2] // e.g.: technosylva.com

    // Only for legacy urls or production.
    fireriskUrl = `https://firerisk${env ? '-' + env : ''}.${domain}`
    firesightUrl = `https://firesight${env ? '-' + env : ''}.${domain}`
    planningUrl = `https://planning${env ? '-' + env : ''}.${domain}`
    if (env === undefined /* production */) {
      OpsUrl = `https://ops.${domain}`
      // Guess pending a real production deployment decision for resource-dispatcher.
      webDispatcherUrl = `https://web-dispatcher.${domain}`
    }
  } else {
    throw new Error('Unexpected URL format: ' + window.location.hostname)
  }
}

export { fireriskUrl, firesightUrl, planningUrl, OpsUrl, webDispatcherUrl, weatherUrl }

export function resolveAppLink(slug: string): string | undefined {
  switch (slug) {
    case 'firerisk':
      return fireriskUrl
    case 'ops':
      return OpsUrl
    case 'firesight':
      return firesightUrl
    case 'planning':
      return planningUrl
    case 'web-dispatcher':
      return webDispatcherUrl
    case 'weather':
      return weatherUrl
    default:
      return undefined
  }
}
